import React, { useEffect, useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import CardContent from "@mui/material/CardContent";
import Email from "@mui/icons-material/Email";
import PublicSharpIcon from '@mui/icons-material/PublicSharp';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import "./CompanyProfile.scss";
import CompanyServices from "./CompanyServices";
import { NavLink, useLocation } from "react-router-dom";
import CompanyFinancialProtection from "./CompanyFinancialProtection";
import { MembershipModel } from "model/screensModels/membership/MembershipModel";
import { UtilService } from "services/shared/UtilService";
import { msgTypes } from "constants/msgTypes";
import { LocalStorageService } from 'services/auth/LocalStorageService';
import ApiUrl from "services/shared/ApiUrl";
import MembershipCertificate from "screens/sharedScreens/dashboard/MembershipCertificate";
import { ContactPersonModel } from "model/screensModels/membership/ContactPersonModel";
import { useNavigate } from "react-router-dom";
import { RouteType } from "constants/RouteType";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import EditNoteIcon from '@mui/icons-material/EditNote';
import MessageIcon from '@mui/icons-material/Message';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import DescriptionIcon from '@mui/icons-material/Description';
import { MembershipAddressModel } from "model/screensModels/membership/MembershipAddressModel";
import CompanyBranches from "./CompanyBranches";
import AddIcon from '@mui/icons-material/Add';
import DispalyImage from "components/wrapperComponents/DispalyImage";
import DOMPurify from 'dompurify';

const CompanyProfile = () => {
  const location = useLocation();
  const [selectedCompanyId, setSelectedCompanyId] = useState(undefined);
  const [companyData, setCompanyData] = useState(new MembershipModel());
  //const [companyHeadOfficeAddress, setCompanyHeadOfficeAddress] = useState(new MembershipAddressModel());
  const [representativeDetails, setRepresentativeDetails] = useState(new ContactPersonModel())
  const [selfProfile, setSelfProfile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.companyId) {
      setSelectedCompanyId(location.state.companyId);
      setSelfProfile(false);
    } else {
      getCompanyIdByLocalStorage();
      setSelfProfile(true);
    }
  }, []);

  useEffect(() => {
    if (selectedCompanyId != undefined)
      companyDetails();
  }, [selectedCompanyId])


  const getCompanyIdByLocalStorage = async () => {
    const userDetails = JSON.parse(await LocalStorageService.getUserDetails());
    setSelectedCompanyId(userDetails.companyId);
  }


  const companyDetails = async () => {
    const requestBody = new MembershipModel();
    requestBody.companyId = selectedCompanyId;

    const res = await UtilService.getCompanyDetailsByCompanyId(requestBody);
    // console.log("Company Detail is", res);

    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      // ✅ Find the correct company object from array
      const selectedCompany = res.data.find(
        (company: any) => company.companyId === selectedCompanyId
      );

      if (selectedCompany) {
        setCompanyData(selectedCompany); // ✅ This is now an object with contactPerson field
        const representative = selectedCompany.contactPerson?.filter(
          (data: ContactPersonModel) => data.contactIsrepresentative === true
        );
        setRepresentativeDetails(representative?.[0]);
      }
    }
  };


  const onClickQuotes = () => {
    if (selfProfile) {
      navigate(RouteType.HOME + RouteType.MEMBER_SEARCH);
    } else {
      navigate(RouteType.HOME + RouteType.MEMBER_SEARCH, {
        state: { selectedCompanyId },
      });
    }
  }

  const onClickMessage = () => {
    if (selfProfile) {
      navigate(RouteType.HOME + RouteType.CHAT_MEET);
    } else {
      navigate(RouteType.HOME + RouteType.CHAT_MEET, {
        state: { selectedCompanyId },
      });
    }
  }

  const onClickInvoice = () => {
    if (selfProfile) {
      navigate(RouteType.HOME + RouteType.INVOICE_MANAGEMENT);
    } else {
      navigate(RouteType.HOME + RouteType.INVOICE_MANAGEMENT, {
        state: { selectedCompanyId },
      });
    }
  }

  const onClickEditProfile = (companyId: string) => {
    if (selfProfile) {
      // navigate(RouteType.HOME + RouteType.UPDATE_MEMBERSHIP, { state: { addBranch: false, companyId: companyId } });
      navigate(RouteType.HOME + RouteType.UPDATE_MEMBERSHIP, {
        state: {
          addBranch: false,
          companyId: companyId,
          companyData: companyData
        },
      });

    }
  }

  const addBranch = () => {
    if (selfProfile) {
      navigate(RouteType.HOME + RouteType.UPDATE_MEMBERSHIP, { state: { addBranch: true } });
    }
  }


  const companyAddress = `${companyData?.addressLine1},${companyData?.addressLine2}, ${companyData?.cityName},${companyData?.stateName}, ${companyData?.countryName}-${companyData?.zipCode}`;
  const googleMapsUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    `${companyAddress}`
  )}&output=embed`;




  return (
    <>
      {companyData ? (


        <div className="container certificate-user-diduct mt-3">
          <div>
            <div className="page-header min-height-300 border-radius-xl mt-4">
              <span className="mask bg-gradient-primary opacity-6"></span>
              <span className="mask-one">
                < DispalyImage
                  imageUrl={companyData?.companyLogo}
                  imageSize={msgTypes.IMAGE_SIZE.LARGE} />
                {/* <img src={ApiUrl.fileBaseUrl + companyData?.companyLogo} alt="" /> */}
              </span>
            </div>
            <div className="card card-body border-0 blur bg-transparent-list shadow-blur mx-3 mt-n6 overflow-hidden">
              <div className="d-flex justify-content-between flex-wrap align-items-center gx-4">
                <div>
                  <div className="materials">
                    <div className="avatar avatar-xl overflow-hidden border-radius-lg shadow-sm position-relative">
                      {/* <img
                        src={representativeDetails?.contactPersonImage ? ApiUrl.fileBaseUrl + representativeDetails.contactPersonImage : "/images/user.png"}
                        alt="profile_image"
                        className={representativeDetails?.contactPersonImage ? ApiUrl.fileBaseUrl + representativeDetails.contactPersonImage : "w-auto"}
                      /> */}
                      <img
                        src={
                          representativeDetails?.contactPersonImage
                            ? ApiUrl.fileBaseUrl + representativeDetails.contactPersonImage
                            : "/images/user.png"
                        }
                        alt="profile_image"
                        className={
                          representativeDetails?.contactPersonImage ? "" : "w-auto"
                        }
                      />

                    </div>
                    <div className="h-100">
                      <p className="mb-0 font-weight-bold text-md">{representativeDetails?.name}</p>
                      <p className="mb-0 text-sm">{representativeDetails?.position} </p>
                      <p className="mb-0 text-sm">{companyData?.companyName} </p>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="nav-wrapper position-relative end-0">
                    <ul className="nav nav-pills nav-fill p-1 bg-transparent justify-content-end" role="tablist">
                      {selfProfile && (
                        <>
                          {companyData.isHeadOffice && (
                            <li className="nav-item mb-2 active">
                              <a onClick={addBranch} className="nav-link shadow-blur">
                                <AddIcon />
                                <span className="ms-1">Add Branch</span>
                              </a>
                            </li>
                          )}
                          <li className="nav-item mb-2 active">
                            <a onClick={() => { onClickEditProfile(companyData.companyId) }} className="nav-link shadow-blur">
                              <EditNoteIcon />
                              <span className="ms-1">Edit Profile</span>
                            </a>
                          </li>
                        </>
                      )}
                      <li className="nav-item mb-2 active">
                        <a onClick={onClickQuotes} className="nav-link shadow-blur">
                          <NoteAltIcon />
                          <span className="ms-1">Quotes</span>
                        </a>
                      </li>
                      <li className="nav-item mb-2">
                        <a onClick={onClickMessage} className="nav-link shadow-blur">
                          <MessageIcon />
                          <span className="ms-1">Message</span>
                        </a>
                      </li>
                      <li className="nav-item mb-2">
                        <a onClick={onClickInvoice} className="nav-link shadow-blur">
                          <DescriptionIcon />
                          <span className="ms-1">Invoice</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div >
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                {/* <div className="col-12">
                  <CompanyFinancialProtection companyId={companyData?.companyId} />
                </div> */}
                <div className="col-12 mt-4">
                  <div className="row">
                    <div className="col-xl-4 company-dashboard card--">
                      <CompanyServices companyId={companyData?.companyId} />
                    </div>
                    <div className="col-md-6 col-xl-4 card-- company-dashboard">
                      <div className="card border-0 h-100">
                        <div className="card-header pb-0 p-3">
                          <div className="row">
                            <div className="col-md-8 d-flex align-items-center">
                              <h6 className=" mb-0">Profile</h6>
                            </div>
                          </div>
                        </div>
                        <div className="card-body p-3">
                          <p className="company-text-one text-sm" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(companyData.companyDetails || "") }}></p>
                          <ul className="list-group pt-4 pb-4">
                            <li className="list-group-item border-0 ps-0 pt-0 mb-2 text-sm">
                              <strong className="text-dark-one">Company Name:</strong> &nbsp; {companyData.companyName}
                            </li>
                            <li className="list-group-item border-0 pt-0 ps-0 mb-2 text-sm">
                              <strong className="text-dark-one">Mobile:</strong> &nbsp; {companyData.primaryPhoneNumber}
                            </li>
                            <li className="list-group-item border-0 pt-0 ps-0 mb-2 text-sm">
                              <strong className="text-dark-one">Email:</strong> &nbsp; {companyData.companyEmail}
                            </li>
                            <li className="list-group-item border-0 pt-0 ps-0 mb-2 text-sm">
                              <strong className="text-dark-one">Location:</strong> &nbsp; {companyData.addressLine1 + ','}
                              {companyData.addressLine2 + ','}
                              {companyData.cityName}{companyData.cityName !== null && ','}
                              {companyData.stateName}{companyData.stateName !== null && ','}
                              {companyData.countryName}, {companyData.zipCode}
                            </li>
                            <li className="list-group-item border-0 pt-0 d-flex ps-0 mb-2 pb-0">
                              <strong className="text-dark-one text-sm">Social Media:</strong> &nbsp;  &nbsp;
                              <Stack direction="row" spacing={.5}>
                                {companyData.companyEmail !== "" &&
                                  (<div className="email"><a href={"mailto:" + companyData.companyEmail} target="_blank"><Avatar><Email /></Avatar></a></div>)}
                                {companyData.websiteUrl !== "" &&
                                  (<div className="youtube"><a href={companyData.websiteUrl} target="_blank"><Avatar><PublicSharpIcon /></Avatar></a></div>)}
                                {companyData.linkedinUrl !== "" &&
                                  (<div className="linkdin"><a href={companyData.linkedinUrl} target="_blank"><Avatar><LinkedInIcon /></Avatar></a></div>)}
                                {companyData.instagramUrl !== "" &&
                                  (<div className="instagram"><a href={companyData.instagramUrl} target="_blank"><Avatar><InstagramIcon /></Avatar></a></div>)}
                              </Stack>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xl-4 card-- contact-persons">
                      <div className="card border-0 h-100">
                        <div className="card-header pb-0 p-3">
                          <h6 className="mb-0">Contact Person</h6>
                        </div> <div className="card-body p-3">
                          <ul className="list-group">
                            {/* {Array.isArray(companyData?.contactPerson) &&
                              companyData.contactPerson.map((persons: ContactPersonModel, index) => (
                                <li key={index} className="list-group-item profile-data border-0 d-flex justify-content-between px-0 mb-2">
                                  <div className="d-flex w-100">
                                    <div className="avatar me-3">
                                      {persons.contactPersonImage ? (
                                        <img
                                          src={ApiUrl.fileBaseUrl + persons.contactPersonImage}
                                          alt="kal"
                                          className="user-icon border-radius-lg shadow p-0"
                                        />
                                      ) : (
                                        <img
                                          src="/images/user.png"
                                          alt="kal"
                                          className="user-icon border-radius-lg shadow"
                                        />
                                      )}
                                    </div>
                                    <div className="w-100">
                                      <div>
                                        <h6 className="mb-0 text-sm">{persons?.name}</h6>
                                        <p className="mb-0 text-xs">{persons?.position}</p>
                                      </div>
                                      <div className="d-flex flex-wrap">
                                        <span className="icons-sec">
                                          <EmailOutlinedIcon />
                                          <a href={`mailto:${persons.email}`} target="_blank" rel="noopener noreferrer">
                                            {persons.email}
                                          </a>
                                        </span>
                                        <span className="icons-sec">
                                          <LocalPhoneIcon />
                                          <a href={`tel:${persons.phoneNumber}`} target="_blank" rel="noopener noreferrer">
                                            {persons.phoneNumber}
                                          </a>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </li>
                              ))} */}
                            {Array.isArray(companyData?.contactPerson) &&
                              companyData.contactPerson
                                // ✅ deleteStatus true wale hata diye
                                .filter((person: ContactPersonModel) => person.deleteStatus !== true)
                                .map((person: ContactPersonModel, index) => (
                                  <li
                                    key={person.contactPersonId || index}
                                    className="list-group-item profile-data border-0 d-flex justify-content-between px-0 mb-2"
                                  >
                                    <div className="d-flex w-100">
                                      <div className="avatar me-3">
                                        {person.contactPersonImage ? (
                                          <img
                                            src={ApiUrl.fileBaseUrl + person.contactPersonImage}
                                            alt={person.name}
                                            className="user-icon border-radius-lg shadow p-0"
                                          />
                                        ) : (
                                          <img
                                            src="/images/user.png"
                                            alt={person.name}
                                            className="user-icon border-radius-lg shadow"
                                          />
                                        )}
                                      </div>
                                      <div className="w-100">
                                        <div>
                                          <h6 className="mb-0 text-sm">{person?.name}</h6>
                                          <p className="mb-0 text-xs">{person?.position}</p>
                                        </div>
                                        <div className="d-flex flex-wrap">
                                          <span className="icons-sec">
                                            <EmailOutlinedIcon />
                                            <a
                                              href={`mailto:${person.email}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {person.email}
                                            </a>
                                          </span>
                                          <span className="icons-sec">
                                            <LocalPhoneIcon />
                                            <a
                                              href={`tel:${person.phoneNumber}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                            >
                                              {person.phoneNumber}
                                            </a>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                ))}

                          </ul>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="row">
                    <div className="col-xl-9 col-md-7 card--">
                      <div className="card border-0 h-100">
                        <div className="card-header pb-0 p-3">
                          <div className="row">
                            <div className="col-md-8 d-flex align-items-center">
                              <h6 className="mb-0">Company Location</h6>
                            </div>
                          </div>
                        </div>
                        <div className="card-body p-3">
                          <iframe
                            src={googleMapsUrl}
                            width="100%"
                            height="240"
                            loading="lazy"
                          ></iframe>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-md-5 card--">
                      <MembershipCertificate companyId={selectedCompanyId} selfProfile={selfProfile} />
                    </div>
                  </div>
                </div>
              </div>

              <CompanyBranches companyData={companyData} />

            </div>
          </div>
        </div>

      ) : ""}

    </>
  );
};

export default CompanyProfile;
